import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import s from './NewsItem.module.css';
import { newsApi } from '../../api/news';
import { News } from '../../types/api.types';

export const NewsItem: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [newsItem, setNewsItem] = useState<News | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            loadNewsItem(Number(id));
        }
    }, [id]);

    const loadNewsItem = async (newsId: number) => {
        try {
            setLoading(true);
            const data = await newsApi.getById(newsId);
            console.log('📦 Новость с бэка:', data);
            setNewsItem(data);
        } catch (error) {
            console.error('Ошибка загрузки новости:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className={s.loading}>Загрузка...</div>;
    }

    if (!newsItem) {
        return (
            <div className={s.notFound}>
                <h2>Новость не найдена</h2>
                <button onClick={() => navigate('/news')} className={s.backButton}>
                    Вернуться к новостям
                </button>
            </div>
        );
    }

    return (
        <div className={s.newsItemPage}>
            <h1 className={s.newsItemTitle}>{newsItem.title}</h1>
            <div className={s.newsItemCard}>
                <div className={s.newsItemContent}>
                    <div
                        className={s.newsItemContentHtml}
                        dangerouslySetInnerHTML={{ __html: newsItem.content?.html || '<p>Нет содержимого</p>' }}
                    />
                    <div className={s.newsItemDate}>
                        {new Date(newsItem.dateCreating).toLocaleDateString('ru-RU')}
                    </div>
                </div>
            </div>
        </div>
    );
};